import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 124,
      "name": "sk.svg",
      "url": "https://api.kaufmann-bau.eu/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 126,
      "name": "gb.svg",
      "url": "https://api.kaufmann-bau.eu/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 9,
    "name": "Talianský jazyk",
    "locale": "it",
    "image": {
      "id": 132,
      "name": "it.svg",
      "url": "https://api.kaufmann-bau.eu/files/it.svg?ai=0",
      "custom_title": "it",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 10,
    "name": "Nemecký jazyk",
    "locale": "de",
    "image": {
      "id": 133,
      "name": "de.svg",
      "url": "https://api.kaufmann-bau.eu/files/de.svg?ai=0",
      "custom_title": "de",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 40,
    "name": "Maďarský jazyk",
    "locale": "hu",
    "image": {
      "id": 248,
      "name": "hu.svg",
      "url": "https://api.kaufmann-bau.eu/files/hu-FacRcPzCfXL0za7mzC3oPE6FKNEt2vKfhtRgtgNR.svg?ai=0",
      "custom_title": "hu",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
